import axios from "./api";
class TrainingService {
  getAll() {
    return axios.get(`/trainingPrograms`);
  }
  get(id) {
    return axios.get(`/trainingPrograms/${id}`);
  }
  create(data) {
    return axios.post(`/trainingPrograms`, data);
  }
  update(id, data) {
    return axios.put(`/trainingPrograms/${id}`, data);
  }
  delete(id) {
    return axios.delete(`/trainingPrograms/${id}`);
  }
  // deleteAll() {
  //     return http.delete(`/requesting`);
  // }
  // findByTitle(titre) {
  //     return http.get(`/requesting?titre=${titre}`);
  // }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new TrainingService();
